/** Agent narrative for the household — shown open at the top of the DG tab. */
export function DataGatheringAgentSummary({ summary }: { summary: string }) {
  return (
    <div data-testid="data-gathering-agent-summary">
      <h3 className="text-sm font-semibold text-slate-900 dark:text-white">Agent summary</h3>
      <p className="mt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-300">{summary}</p>
    </div>
  );
}
